import '../../styles/ServiceList.css';

type ServiceListProps = {
  sectionHeading: string;
  items: string[];
};

const ServiceList: React.FC<ServiceListProps> = ({ sectionHeading, items }) => {
  return (
    <section className="serviceList-section">
        <div className='serviceList-content'>
            <p className="sections-title serviceList-heading">{sectionHeading}</p>
            <div className="serviceList-container">
                {items.map((step, index) => (
                <div 
                    key={index} 
                    className="serviceList-card" 
                >
                  <span className="serviceList-card-number">
                    {String(index + 1).padStart(2, '')}
                  </span>
                  <div className='serviceList-card-content'>
                      <p className='serviceList-desc'>{step}</p>
                  </div>
                </div>
                ))}
            </div>
        </div>
    </section>
  );
};

export default ServiceList;